import { OurServicesCompWrapper } from "../../styles/StyledComponents/OurServicesCompWrapper";
import CommonTab from "../../ui/CommonTab/CommonTab";
import { tabMock } from "../../ui/json/offerCard.mock";
import CommonHeading from "../CommonHeading/CommonHeading";

const OurServicesComp = () => {
  return (
    <OurServicesCompWrapper className="cmn_gap_btm">
      {/* <div className="container">
        <CommonHeading
          isPrimary
          title="Our Services"
          className="our_service_heading"
        />
        <div className="row services_Cards_row">
          {servicesMock?.map((data, index) => (
            <div className="services_col" key={index}>
              <CommonOverlayBox isH3 {...data} className="services_bg_Wrap" />
              <div className="row small_card_row">
                {data?.designCardData?.map((item, idx) => (
                  <div className="smCard_col" key={idx}>
                    <SmallDesignCard {...item} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div> */}
      <div className="container">
        <CommonHeading
          title="Our Services"
          isPrimary
          className="our_service_heading"
        />
        <CommonTab tabList={tabMock} />
      </div>
    </OurServicesCompWrapper>
  );
};

export default OurServicesComp;
